import { useMutation } from '@apollo/client';

import { LeaveEventInput } from '../../apollo/__generated__/graphql';
import { LEAVE_EVENT } from '../graphql/mutation/leaveEventMutation.graphql';

export const useLeaveEventMutation = () => {
  const [mutate] = useMutation(LEAVE_EVENT);

  const leaveEvent = (leaveEventInput: LeaveEventInput) => {
    mutate({
      variables: {
        leaveEventInput,
      },
    });
  };

  return { leaveEvent };
};
